var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Delete FTP Account")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "p",
              {
                staticClass: "mb-2"
              },
              [
                _vm._v("Delete account "),
                _c("strong", [_vm._v(_vm._s(_vm.account.user))]),
                _vm._v("?")
              ]
            ),
            _c(
              "p",
              {
                staticClass: "mb-2"
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "pb-1",
                    attrs: {
                      small: ""
                    }
                  },
                  [_vm._v("mdi-folder-outline")]
                ),
                _vm._v(" " + _vm._s(_vm.account.dir))
              ],
              1
            ),
            _c("v-checkbox", {
              staticClass: "mt-1",
              attrs: {
                label: "Delete the User’s Home Directory",
                color: "green",
                "hide-details": ""
              },
              model: {
                value: _vm.destroy,
                callback: function callback($$v) {
                  _vm.destroy = $$v
                },
                expression: "destroy"
              }
            }),
            _c(
              "v-alert",
              {
                staticClass: "py-1",
                attrs: {
                  type: "warning",
                  color: "orange darken-1",
                  value: _vm.destroy,
                  transition: "slide-y-transition"
                }
              },
              [
                _vm._v(
                  " Please ensure that no other users on this account require these files. This option will permanently remove all files in the following directory: "
                ),
                _c("strong", [_vm._v(_vm._s(_vm.account.dir))])
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteAccount
                }
              },
              [_vm._v("Delete")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }